import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import BecomeACoachComponent from "../Front/Pages/Become-a-coach";
import HomeComponent from "../Front/Pages/Home/index";
import LogoutUserHomeComponent from "../Front/Pages/Home/logoutUserHomePage";
import BrowseCoachComponent from "../Front/Pages/Browse-coach";
import BrowseCoachListViewComponent from "../Front/Pages/Browse-coach/listView";
import BrowseCoachGridViewComponent from "../Front/Pages/Browse-coach/gridView";
import CoachDetailsComponent from "../Front/Pages/Browse-coach/coachDetails";
import BlogComponent from "../Front/Pages/Blog";
import UserLayoutComponent from "../User/userLayout";
import UserDashboardComponent from "../User/Pages/Dashboard";
import UserProfileComponent from "../User/Pages/Profile";
import UserSettingComponent from "../User/Pages/Setting";
import UserActivitiesComponent from "../User/Pages/Activities";
import UserMyCoachComponent from "../User/Pages/MyCoach";
import UserScheduleSessionComponent from "../User/Pages/ScheduleSession";
// import UserNotificationComponent from "../User/Pages/Notification";

import UserMessagesComponent from "../User/Pages/Messages";
import HomeLayoutComponent from "../Front/HomeLayout";
import ActivityStreamComponent from "../Front/Pages/Activity-stream";
import SingleFeedComponent from "../Front/Pages/Activity-stream/singleSocialFeed";
import SingleShortComponent from "../Front/Pages/Activity-stream/singleShortVideo";

import CoachLayoutComponent from "../Coach/coachLayout";
import CoachActivitiesComponent from "../Coach/Pages/Activities";
import CoachSettingComponent from "../Coach/Pages/Setting";
import CoachMessagesComponent from "../Coach/Pages/Messages";

import CoachCalendarComponent from "../Coach/Pages/Calendar";
import CoachBookingCalendarComponent from "../Coach/Pages/Calendar/booking";

import CoachProfilePersonalInformationComponent from "../Coach/Pages/Profile/ProfilePersonal";
import CoachProfileAboutYourSelfComponent from "../Coach/Pages/Profile/AboutYourSelf";
import CoachProfileCoachingDetailsComponent from "../Coach/Pages/Profile/CoachingDetails";
import CoachProfileProfessionalDetailsComponent from "../Coach/Pages/Profile/ProfessionalDetails";
import CoachMyProfileComponent from "../Coach/Pages/Profile";
import TermsServicesComponent from "../Front/Pages/TermsServices";
import PrivacyPolicyComponent from "../Front/Pages/PrivacyPolicy";
import UpdatepasswordComponent from "../Front/Pages/Updatepassword";
import ContactUsComponent from "../Front/Pages/ContactUs";
import ProtectedRoute from "./ProtectedRoutes";
import NotFound from "../Front/Pages/NotFound";
import SubmitForm from "../SubmitForm";
import ProgramSessionRules from "../Coach/Pages/Profile/ProgramSessionRules";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CoachProfilePreview from "../Coach/Pages/Profile/ProfilePreview";
import LatestBlogComponent from "../Front/Pages/Blog/latest_blogs_old";
import BlogDetailsComponent from "../Front/Pages/Blog/blog_details";
import CoachBlogComponent from "../Coach/Pages/Blogs";
import CreateBlogComponent from "../Coach/Pages/Blogs/create";

import CanvasWhiteBoardComponent from "../Front/Pages/agora/CanvasWhiteBoard";
import CreateLiveSession from "../Coach/Pages/Activities/createLiveSession";

import { toast } from "react-toastify";
import CoachEarningComponent from "../Coach/Pages/Earnings";
import AboutComponent from "../Front/Pages/About";
import AddAvailabilitySlot from "../Coach/Pages/Bookings/AddAvailabilitySlot";
import AddAvailabilitySlot1 from "../Coach/Pages/Bookings/AddAvailabilitySlot_new_sanju";

import UserUpdateAvailabilityComponent from "../User/Pages/Booking";
import MyProgramsComponents from "../User/Pages/Programs";
import ScheduleSessionComponent from "../Front/Pages/Schedule-session";
import BookingComponentUpcoming from "../User/Pages/Booking/upcomingSession";

import CoachEventCalendarComponent from "../Coach/Pages/Event";
import SessionsComponent from "../Coach/Pages/Sessions";
import AddSessionsComponent from "../Coach/Pages/Sessions/add_sessions";
import FrontProfilePreview from "../Front/Pages/Profile";
import EditProfileComponent from "../User/Pages/Profile/EditProfile";
import PaymentHistoryPage from "../User/Pages/Payment";
import NotificationFrontPage from "../Front/Pages/Notification";
import PopularBlogComponent from "../Front/Pages/Blog/popular_blog";
import AllBlogsComponent from "../Front/Pages/Blog/all_blogs";
import LatestBlogsComponent from "../Front/Pages/Blog/latest_blogs";
import { useUserContext } from "../utils/hooks/UserContext";

const Root = () => {
  const [modalOpen, setModalOpen] = useState(true);
  const [password, setPassword] = useState("");
  const { user, handleLogout, isOpen, setIsOpen } = useUserContext();
  /*   const getData = () => {
    const storedData = localStorage.getItem("websiteDisplay");
    console.log(storedData);
    if (storedData === "true") {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    getData();
  }, []); */

  /*   const openSite = (e) => {
    e.preventDefault();
    if (password === "Admin@123") {
      localStorage.setItem("websiteDisplay", "true");
      setModalOpen(false);
      toast.success("Login successfully");
    } else {
      toast.error("Incorrect password");
    }
  };
  const handleInputChange = (value) => {
    // setInputValue(value);
  }; */
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        z-index="111111"
      />

      <>
        <Routes>
          <Route path="/" element={<HomeLayoutComponent />}>
            <Route index element={<HomeComponent />} />
            <Route
              exact
              path="become-a-coach"
              element={<BecomeACoachComponent />}
            />
            <Route path="browse-coach" element={<BrowseCoachComponent />}>
              <Route
                index
                path="list-view"
                element={<BrowseCoachListViewComponent />}
              />
              <Route
                path="grid-view"
                element={<BrowseCoachGridViewComponent />}
              />
              <Route
                className="sdf"
                path="coach-details/:id"
                element={<CoachDetailsComponent />}
              />
            </Route>
            <Route exact path="blogs" element={<BlogComponent />} />

            <Route exact path="all-blogs" element={<AllBlogsComponent />} />
            <Route
              exact
              path="latest-blogs"
              element={<LatestBlogsComponent />}
            />
            <Route
              exact
              path="popular-blogs"
              element={<PopularBlogComponent />}
            />
            <Route
              exact
              path="blog-details/:id"
              element={<BlogDetailsComponent />}
            />
            <Route
              exact
              path="activity-stream"
              element={<ActivityStreamComponent />}
            />
            <Route
              exact
              path="single-feed/:id"
              element={<SingleFeedComponent />}
            />
            <Route
              exact
              path="single-short/:id"
              element={<SingleShortComponent />}
            />
            <Route exact path="contact-us" element={<ContactUsComponent />} />
            <Route
              exact
              path="terms-of-services"
              element={<TermsServicesComponent />}
            />
            <Route
              exact
              path="privacy-policy"
              element={<PrivacyPolicyComponent />}
            />
            <Route
              exact
              path="updatepassword/:token"
              element={<UpdatepasswordComponent />}
            />
            <Route exact path="about" element={<AboutComponent />} />
            <Route
              exact
              path="schedule-session"
              element={<ScheduleSessionComponent />}
            />
            <Route
              exact
              path="upcoming-session"
              element={<BookingComponentUpcoming />}
            />
            <Route
              exact
              path="profile-preview"
              element={<FrontProfilePreview />}
            />
            <Route
              exact
              path="notification"
              element={<NotificationFrontPage />}
            />

            {/* BookingComponentUpcoming */}
          </Route>

          <Route
            path="user"
            element={
              <ProtectedRoute auth={["user"]}>
                <UserLayoutComponent />
              </ProtectedRoute>
            }
          >
            <Route
              path="profile"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserProfileComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserDashboardComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile/edit-profile"
              element={
                <ProtectedRoute auth={["user"]}>
                  <EditProfileComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="messages"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserMessagesComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="setting"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserSettingComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="activities"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserActivitiesComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="my-coach"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserMyCoachComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="schedule-session"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserScheduleSessionComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="update-availability"
              element={
                <ProtectedRoute auth={["user"]}>
                  <UserUpdateAvailabilityComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="my-programs"
              element={
                <ProtectedRoute auth={["user"]}>
                  <MyProgramsComponents />
                </ProtectedRoute>
              }
            />
            {/* upcoming-session */}
            <Route
              path="upcoming-session"
              element={
                <ProtectedRoute auth={["user"]}>
                  <BookingComponentUpcoming />
                </ProtectedRoute>
              }
            />
            <Route
              path="payment-history"
              element={
                <ProtectedRoute auth={["user"]}>
                  <PaymentHistoryPage />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route
            path="coach"
            element={
              <ProtectedRoute auth={["coach"]}>
                <CoachLayoutComponent />
              </ProtectedRoute>
            }
          >
            <Route
              index
              path="profile"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachMyProfileComponent />
                </ProtectedRoute>
              }
            />
            <Route
              index
              path="preview"
              element={
                <ProtectedRoute auth={["coach"]}>
                  {" "}
                  <CoachProfilePreview />{" "}
                </ProtectedRoute>
              }
            />

            <Route
              index
              element={<CoachProfilePersonalInformationComponent />}
            />
            {/* <Route index path="personal-information"  element={<CoachProfilePersonalInformationComponent />} /> */}
            <Route
              exact
              path="about-yourself"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachProfileAboutYourSelfComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="coaching-details"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachProfileCoachingDetailsComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="professional-details"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachProfileProfessionalDetailsComponent />
                </ProtectedRoute>
              }
            />
            {/* programSessionRule */}
            <Route
              exact
              path="program-session"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <ProgramSessionRules />
                </ProtectedRoute>
              }
            />

            <Route
              exact
              path="my-activities"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachActivitiesComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="earnings"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachEarningComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="setting"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachSettingComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="messages"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachMessagesComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="my-blogs"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachBlogComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="my-blogs/create"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CreateBlogComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="my-blogs/create/:blogId"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CreateBlogComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="my-activities/create"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CreateLiveSession />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="my-calendar"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachCalendarComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="booking"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <CoachBookingCalendarComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="add-availability"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <AddAvailabilitySlot />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="add-availabilitys"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <AddAvailabilitySlot1 />
                </ProtectedRoute>
              }
            />

            <Route
              exact
              path="sessions"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <SessionsComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="sessions/add-session"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <AddSessionsComponent />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="sessions/add-session/:sessionId"
              element={
                <ProtectedRoute auth={["coach"]}>
                  <AddSessionsComponent />
                </ProtectedRoute>
              }
            />

            {/* <Route exact path="/event-whiteBoard/:id" element={<ProtectedRoute auth={["coach"]} ><CanvasWhiteBoardComponent /></ProtectedRoute>} /> */}
          </Route>
          <Route
            path="event-whiteBoard/:id"
            element={<CanvasWhiteBoardComponent />}
          />

          <Route path="submit" element={<SubmitForm />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <div
          style={{ zIndex: "+9999" }}
          className="bottom-0 p-2 text-center bg-black position-fixed w-100 fs-12 z-3"
        >
          <p className="m-0 text-white">Beta Version</p>
        </div>
      </>
    </>
  );
};

export default Root;
